import {
  DefaultButton,
  DocumentCard,
  DocumentCardDetails,
  DocumentCardImage,
  DocumentCardTitle,
  ImageFit,
} from "@fluentui/react";
import React, { MutableRefObject, useRef } from "react";
import { useDispatch } from "react-redux";
import { maxImageSizeInBytes } from "../../common/commonConstants";
import { deleteStationImage, invalidFileForImageUpload, uploadStationImage } from "../../reducers/diningReducer";
import styles from "../../styles/stationImageList.module.css";

const acceptedImageTypes = ["image/jpg", "image/jpeg", "image/png"];

type Props = {
  name: string;
  cafeId: string;
  stationId: string;
  imageUrl?: string;
};

const StationImageCard = (props: Props) => {
  const uploadRefs: MutableRefObject<{ [stationId: string]: HTMLInputElement | null }> = useRef<{
    [stationId: string]: HTMLInputElement | null;
  }>({});

  const dispatch = useDispatch();

  const uploadImage = (files: FileList | null) => {
    if (
      files === null ||
      files.length === 0 ||
      files[0].size > maxImageSizeInBytes ||
      !acceptedImageTypes.includes(files[0].type)
    ) {
      dispatch(invalidFileForImageUpload());
      return;
    }

    dispatch(
      uploadStationImage(props.cafeId, props.stationId, {
        data: files[0],
        fileName: files[0].name,
      }),
    );
  };

  const deleteImage = () => {
    dispatch(deleteStationImage(props.cafeId, props.stationId));
  };

  return (
    <DocumentCard className={styles.card}>
      {/* @ts-ignore */}
      <DocumentCardDetails>
        <h3 className={styles.cardCategory}>Station image</h3>
        <DocumentCardTitle className={styles.cardTitle} title={props.name} />
        <DocumentCardTitle className={styles.cardSubtitle} title="Station image preview" />
      </DocumentCardDetails>
      <div className={styles.imageContainer}>
        <DocumentCardImage
          className={styles.cardImage}
          height={150}
          imageFit={ImageFit.centerContain}
          imageSrc={props.imageUrl || "../../images/image-icon.svg"}
          iconProps={{
            "aria-label": props.imageUrl ? props.name : "No image selected",
            imageErrorAs: () => <img src="../../images/image-icon.svg" />,
          }}
        />
        {props.imageUrl && (
          <button
            className={styles.deleteImageButton}
            data-testid={"deleteButton"}
            onClick={() => deleteImage()}
            aria-label={`Remove image for station ${props.name}`}
          >
            <span aria-hidden={true}>&#10006;</span>
          </button>
        )}
      </div>
      <div className={styles.cardActions}>
        <label>
          <div className={styles.browseLabel}>Change station&apos;s image</div>
          <input
            className={styles.hidden}
            type={"file"}
            accept={"image/jpg, image/jpeg, image/png"}
            ref={(ref) => (uploadRefs.current[props.stationId] = ref)}
            onChange={(e) => uploadImage(e.target.files)}
          />
          <DefaultButton text={"Browse"} onClick={() => uploadRefs.current[props.stationId]?.click()} />
        </label>
      </div>
    </DocumentCard>
  );
};

export default StationImageCard;
